import cloneDeep from 'lodash/cloneDeep';

const DEFAULT_STATE = {
    refresh: false,
    success: true,
    loaded: false,
    error: null,
    user: null,
    userLoggedIn: false,
    userCardType: '',
    currentMarket: null,
    lang: 'en'
};

export default cloneDeep(DEFAULT_STATE);